<template>
  <div class="page-container flex-column">
    <NewProjectSearchBar :on-search="onSearch" :hide-search-member="tabName !== '全部'" @tableTypeChange="tableTypeChange" class-name="col-0" />
    <NewProjectTable
      ref="projectTable"
      class-name="col-1 scroll projects-projecttable"
      :table-type="tableType"
      @changeActiveTab="changeActiveTab"
    />
  </div>
</template>

<script>
import NewProjectSearchBar from '../components/NewProjectSearchBar.vue'
import NewProjectTable from '../components/NewProjectTable.vue'

export default {
  components: { NewProjectSearchBar, NewProjectTable },
  data() {
    return {
      tabName: '全部',
      tableType: '阶段模式',
    }
  },
  methods: {
    // onSearch(query, sortType) {
    //   this.$refs.projectTable.setQuery(query, sortType)
    // },
    tableTypeChange(type){
      this.tableType = type
    },
    onSearch(query) {
      this.$refs.projectTable.setQuery(query)
    },
    getProjects() {
      this.$refs.projectTable.getProjects()
    },
    changeActiveTab(tabName) {
      this.tabName = tabName
    },
  },
}
</script>
